import type { SpotResultsInfoTextAttributes } from '@/features/spot-results/spot-results-v4/spot-results-v4-type';

import React from 'react';

import { HtmlTextWrapper, IconImage } from '@/core/features';
import color from '@/core/features/styles/color';

export default function SpotResultsInfoTextDesktop({ htmlText, iconUrl }: SpotResultsInfoTextAttributes) {
    return (
        <div className={'flex flex-col items-center gap-10'}>
            {iconUrl && (
                <IconImage
                    alt={'Info Icon'}
                    height={20}
                    url={iconUrl}
                    width={20}
                />
            )}
            <HtmlTextWrapper
                className={'text-center'}
                htmlText={htmlText}
                // eslint-disable-next-line no-inline-styles/no-inline-styles
                style={{ color: color('codGray'), lineHeight: 1.3, maxWidth: 792 }}
            />
        </div>
    );
}
